import { PropsWithChildren, createContext, useContext, useState } from "react";

import { ChartSettings } from "../hooks/charts";
import { EntityKind } from "../models/entityKind";

export enum ChartStatus {
  Loading = "loading",
  Error = "error",
  Idle = "idle"
}

interface ChartContextProps {
  id: string;
  entityKind: EntityKind;
  status: ChartStatus;
  setStatus: (newStatus: ChartStatus) => void;
  isPopout?: boolean;
  initialChartSettings: ChartSettings;
}

export const ChartContext = createContext<ChartContextProps | undefined>(undefined);

export const useChartsContext = () => {
  const context = useContext(ChartContext);
  if (!context) {
    throw new Error("useChartContext must be used within a ChartProvider");
  }
  return context;
};

interface ChartProviderProps {
  id: string;
  entityKind: EntityKind;
  initialChartSettings: ChartSettings;
}

export const ChartsProvider = ({
  id,
  entityKind,
  initialChartSettings,
  children
}: PropsWithChildren<ChartProviderProps>) => {
  const [status, setStatus] = useState(ChartStatus.Idle);
  return (
    <ChartContext.Provider
      value={{ id, entityKind, status, setStatus, initialChartSettings }}>
      {children}
    </ChartContext.Provider>
  );
};
